{
  "kyc": {
    "port": 5002
  },
  "tagging": {
    "port": 5003
  },
  "integrations": {
    "port": 5004
  },
  "databases": {
    "port": 5005
  },
  "rdi": {
    "port": 5006
  },
  "subscriptions": {
    "port": 5007
  },
  "billings": {
    "port": 5010
  },
  "aiservices": {
    "port": 5011
  },
  "shaka": {
    "port": 5012
  }
}
